var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notifications'),_c('transition',{attrs:{"name":"fade"}},[(_vm.showPage)?_c('router-view'):_vm._e()],1),_c('Popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }